let toastContext = null;

export const setToastContext = (context) => {
  toastContext = context;
};

export const showSuccess = (msg) => {
  if (toastContext) {
    toastContext.showToast(msg, 'success');
  } else {
    console.log('Success:', msg);
  }
};

export const showError = (msg) => {
  if (toastContext) {
    toastContext.showToast(msg, 'error');
  } else {
    console.error('Error:', msg);
  }
};

export const showInfo = (msg) => {
  if (toastContext) {
    toastContext.showToast(msg, 'info');
  } else {
    console.info('Info:', msg);
  }
};